import { Brand } from 'backend';
import { useFile } from 'helpers';
import { camelCase } from 'lodash';
import React from 'react';

export const useFonts = (
  { name, font_brand, font_cover }: Brand,
  typeface?: string | null,
) => {
  const fontBrand = useFile(font_brand);
  const fontCover = useFile(font_cover);

  let weights = ['400', '600', '700'];
  const fonts = {} as any;
  if (!!typeface && typeface.startsWith('custom') && font_cover)
    fonts['--custom-title-font-family'] = `${camelCase(name)}Title`;
  if (!!typeface && typeface.startsWith('custom') && font_brand)
    fonts['--custom-brand-font-family'] = `${camelCase(name)}Brand`;

  // load google font
  if (!!typeface && typeface.startsWith('google:')) {
    const fontName = typeface.split(':')[1];
    fonts['--custom-title-font-family'] = fontName
      .split('@')[0]
      .replace(/\+/g, ' ');
    fonts['--custom-title-font-weight'] = fontName.split('@')[1] ?? '400';
    weights.push(fontName.split('@')[1] ?? '400');
    fonts['--custom-brand-font-family'] = fontName
      .split('@')[0]
      .replace(/\+/g, ' ');
    fonts['--custom-brand-font-weight'] = '400';
  }

  const style = { ...fonts } as React.CSSProperties;

  weights = weights
    .filter((v, i, a) => a.indexOf(v) === i)
    .sort((a, b) => parseInt(a) - parseInt(b));

  const resources = (
    <>
      {!!typeface && typeface.startsWith('google:') && (
        <link
          href={`https://fonts.googleapis.com/css2?family=${typeface
            .split('@')[0]
            .replace('google:', '')}:wght@${weights.join(';')}&display=block`}
          rel="stylesheet"
        />
      )}
      {!!typeface && typeface.startsWith('custom') && font_brand && (
        <style>
          {`@font-face {
            font-family: ${camelCase(name)}Brand;
            src: url(${fontBrand});
            font-weight: bold;
            font-display: swap;
            font-style: normal;
          }`}
        </style>
      )}
      {!!typeface && typeface.startsWith('custom') && font_cover && (
        <style>
          {`@font-face {
            font-family: ${camelCase(name)}Title;
            src: url(${fontCover});
            font-weight: bold;
            font-display: swap;
            font-style: normal;
          }`}
        </style>
      )}
    </>
  );

  return {
    style,
    resources,
    customType: !!typeface || !!font_cover || !!font_brand,
  };
};
